import { gql, TypedDocumentNode } from "@apollo/client";

import {
  TransferNoteOwnershipMutation,
  TransferNoteOwnershipMutationVariables,
} from "./TransferNotes.generated";

export const TRANSFER_NOTES: TypedDocumentNode<
  TransferNoteOwnershipMutation,
  TransferNoteOwnershipMutationVariables
> = gql`
  mutation transferNoteOwnership(
    $noteUuids: [String]
    $newOwnerUuid: String
    $newTeamUuid: String
    $applyCustomDefaults: Boolean
  ) {
    transferNoteOwnership(
      noteUuids: $noteUuids
      newOwnerUuid: $newOwnerUuid
      newTeamUuid: $newTeamUuid
      applyCustomDefaults: $applyCustomDefaults
    ) {
      ok
      failedNotes
    }
  }
`;
